const state = {
    auth: {
        token: undefined
    },
    userInfo: {}
}

const getters = {

}

const actions = {

}

const mutations = {
    setAuth (state, val) {
        state.auth = {
            token: val?.token || undefined
        }
    },

    setUserInfo (state, val) {
        state.userInfo = val
    },

    clearUserInfo (state) {
        state.userInfo = {}
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
